/**
 * Card — base panel container used across dashboards and tables. Sober border
 * + xs shadow + md radius per design-system.md §6/§7.
 */
import type { ReactNode } from 'react';
import { cn } from './cn';

export interface CardProps {
  className?: string;
  children: ReactNode;
}

export function Card({ className, children }: CardProps): JSX.Element {
  return (
    <div className={cn('rounded-md border border-border-subtle bg-surface shadow-xs', className)}>
      {children}
    </div>
  );
}

// Consumers wrote `import { Card, CardHeader } from "./Card"`. Re-import +
// re-export (rather than `export { ... } from`) so the live binding lands in
// Card's own export map — Vite's dev runtime sometimes mis-detects pure
// `export {} from` re-exports.
import { CardHeader as _CardHeader } from './CardHeader';
export type { CardHeaderProps } from './CardHeader';
export const CardHeader = _CardHeader;
